
export default {
  name: `ProviderInfo`,
  props: {
    readonly: {
      type: Boolean,
      default: false
    },
    formErrors: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      form: {}
    }
  },
  computed: {
    provider() {
      return this.$store.getters[`integrations/selectedProvider`]
    }
  },
  mounted() {
    this.form = { ...(this.provider.form_fields || {}) }
  },
  methods: {
    updateProviderData(field, value) {
      this.$store.commit(`integrations/updateProviderField`, {field, value})
    },
    formatLabel(key) {
      return key
        .replace(/_/g, ` `)
        .replace(/\b\w/g, l => l.toUpperCase())
    }
  }
}
